/**
 * Created by mzietek on 2016-12-07.
 */


(function (angular) {
    'use strict';

    angular
        .module("repairforms.factory.module")
        .factory("TypeOfServiceOptionsFactory", TypeOfServiceOptionsFactory);

    TypeOfServiceOptionsFactory.$inject = ['$filter'];

    function TypeOfServiceOptionsFactory($filter) {

        return {
            getOptions : getOptions,
            getDisplayOption : getDisplayOption
        };

        function getOptions() {
            return {
                 REPAIR: 'REPAIR',
                 WARRANTY: 'WARRANTY'
            };
        }

        function getDisplayOption(typeOfService) {
            var res = '';
            var options = this.getOptions();
            switch(typeOfService) {
                case options.REPAIR:
                    res = $filter('translate')("summary.repair");
                    break;
                case options.WARRANTY:
                    res = $filter('translate')("summary.warranty");
                    break;
                default:
                    break;
            }
            return res;
        }
    }

})(angular);